import React from 'react';

/** ************************ COMPONENTS  ***********************8 */
import { Button,Slide , Modal, ModalOverlay , ModalHeader , ModalCloseButton , ModalBody , ModalFooter, ModalContent } from '@chakra-ui/react';
/** ************************ HELPERS  **************** */
function CustomModel({ title,disabled = false, children, isOpen, setisOpen , isLoading = false, handleSuccess, successLabel = 'Submit' }) {
    const onClose = ()=>{
        setisOpen(!isOpen);
    };
    return (
        <Slide direction='top' in={isOpen}>
            <Modal isCentered blockScrollOnMount={false} isOpen={isOpen} onClose={onClose} >
                <ModalOverlay />
                <ModalContent maxWidth={'50vw'}>
                    <ModalHeader>{title}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {children}
                    </ModalBody>
                    <ModalFooter>
                        <Button mr={3} onClick={onClose} >
                            Close
                        </Button>
                        <Button disabled={disabled || isLoading} type='button' colorScheme='danger' isLoading={isLoading} onClick={handleSuccess} loadingText={'Sending.. '} variant='brand'>
                            { successLabel }
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Slide>
    );
}

export default CustomModel;
